// extracted by mini-css-extract-plugin
export default {"failureReason":"DeliveryIssuesTable_failureReason__X45jO"};